import { AxiosResponse, CancelTokenSource } from 'axios';
import API from './index';

export default class SearchAPI extends API {
  searchRestaurantsAndCategories(
    searchString: string,
    cancelToken: CancelTokenSource,
  ): Promise<
    AxiosResponse<{
      restaurants: [
        {
          id: number;
          name: string;
          city: string;
          categories: string;
          priceCategoryId: number;
          slug: string;
        },
      ];
    }>
  > {
    return this._get(`/web/search/globalsearch/${searchString}`, {
      cancelToken: cancelToken.token,
    });
  }
}
